import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import requester from '@/lib/axios';
import {
  FillInTheBlankQuestion,
  FillInTheBlankQuestionCreateDTO,
} from '@/models/Question';
import {
  convertToFormData,
  feedbacksConverter,
  jsonFieldConverter,
} from '@/utils/convertToFormData';
import { jsonToFormData } from '@/utils/shared/jsonToFormData';

const baseUrl = 'fill-in-the-blank-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

const converters = {
  title: jsonFieldConverter,
  context: jsonFieldConverter,
  feedbacks: feedbacksConverter,
};

export const getFillInTheBlankQuestion = async (id: number) => {
  const { data } = await requester().get<FillInTheBlankQuestion>(
    `${baseUrl}/${id}/`,
  );
  return data;
};

export const createFillInTheBlankQuestionIntoActivity = async (
  activityId: number,
  {
    title,
    context,
    feedbacks,
    ...body
  }: Partial<FillInTheBlankQuestionCreateDTO>,
) => {
  const formData = jsonToFormData(body);
  convertToFormData({ title, context, feedbacks }, converters, formData);

  const { data } = await requester().post<FillInTheBlankQuestion>(
    `${nestedUrl(activityId)}/`,
    formData,
    { headers },
  );
  return data;
};

export const updateFillInTheBlankQuestionIntoActivity = async (
  activityId: number,
  id: number,
  {
    title,
    context,
    feedbacks,
    ...body
  }: Partial<
    Pick<
      FillInTheBlankQuestionCreateDTO,
      'title' | 'context' | 'question' | 'options' | 'feedbacks'
    >
  >,
) => {
  const formData = jsonToFormData(body);
  convertToFormData({ title, context, feedbacks }, converters, formData);

  const { data } = await requester().patch<FillInTheBlankQuestion>(
    `${nestedUrl(activityId)}/${id}/`,
    formData,
    { headers },
  );
  return data;
};

export const deleteFillInTheBlankQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
